<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="https://s3-ap-southeast-1.amazonaws.com/ccpl-logo/CCPL_Logo_2.png" width="89" height="25" alt="CCPL Logo">
        <img class="navbar-brand-minimized" src="https://s3-ap-southeast-1.amazonaws.com/ccpl-logo/CCPL_Logo_1.png" width="30" height="30" alt="CCPL Logo">
      </b-link>
      <!-- <SidebarToggler class="d-md-down-none" display="lg" /> -->
      <b-navbar-nav class="ml-auto mr-4">
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" />
      <AsideToggler class="d-lg-none" mobile /> -->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <!-- <Breadcrumb :list="list"/> -->
        <div class="container-fluid mt-3">
          <router-view></router-view>
        </div>
      </main>
      <!-- <AppAside fixed>
        <DefaultAside/>
      </AppAside> -->
    </div>
    <TheFooter fixed>
      <!--footer-->
      <div>
        <span>&copy; {{year}} Carclub Pte Ltd.</span>
        <span class="d-md-down-none">&nbsp;|&nbsp;{{appVersion}}</span>
      </div>
      <div class="ml-auto">
        <span v-text="currentTime"></span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import moment from 'moment'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'full',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
      nav: nav.items,
      currentTime: null,
      year: moment().year(),
      appVersion: `v${process.env.VUE_APP_VERSION}`
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  },
  methods: {
    updateCurrentTime() {
      this.currentTime = moment().format('YYYY-MM-DD | HH:mm:ss');
    }
  },
  created () {
    this.currentTime = moment().format('HH:mm:ss');
    setInterval(() => this.updateCurrentTime(), 1 * 1000);
  }
}
</script>
